/* eslint-disable @angular-eslint/component-selector */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PASCompleteService } from '@core/index';
import { SubSink } from 'subsink';

@Component({
    selector: 'pac-provider-dashboard-wrapper',
    template: `
    <mnc-pac-provider-dashboard
      lazyComponent
      [tenantId]="tenantId"
      (routeToAuth)="routeToAuth($event.detail)"
      (routeToContinuedStay)="routeToContinuedStay($event.detail)"
      (routeToAuthRequest)="routeToAuthRequest($event.detail)"
      (routeToHomeHealthAuthRequest)="routeToHomeHealthAuthRequest($event.detail)"
    ></mnc-pac-provider-dashboard>
  `,
    standalone: false
})
export class ProviderDashboardComponent implements OnInit, OnDestroy {
  private readonly subs = new SubSink();

  tenantId: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private pasCompleteService: PASCompleteService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.subs.sink = this.activatedRoute.params.subscribe((params) => {
      this.tenantId = params['tenantId'];
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  routeToAuth(
    { authorizationNumber, product, state }: { authorizationNumber: string, product: string, state?: { [k: string]: any } }
  ) : void {
    this.router.navigate(
      [
        this.tenantId,
        product,
        'auth-dashboard',
        authorizationNumber,
      ],
      { state: state ?? {} }
    );
  }

  routeToContinuedStay(
    { authorizationNumber, product, state }: { authorizationNumber: string, product: string, state?: { [k: string]: any } }
  ) : void {
    this.router.navigate(
      [
        this.tenantId,
        product,
        'continued-stay',
        authorizationNumber,
      ],
      { state: state ?? {} }
    );
  }

  routeToAuthRequest(
    { memberId, product, state }: { memberId: string, product: string, state?: { [k: string]: any } }
  ) : void {
    this.router.navigate(
      [
        this.tenantId,
        product,
        'member',
        memberId,
        'request-initial',
      ],
      { state: state ?? {} }
    );
  }

  routeToHomeHealthAuthRequest(
    { subscriberNumber, state }: {
      subscriberNumber: string,
      state?: { authorizationByProductId?: string, authorizationNumber?: string, [k: string]: any }
    }
  ) : void {
    this.pasCompleteService.setIsHhAuthForPacUser(true);

    this.router.navigate(
      [
        this.tenantId,
        'member',
        subscriberNumber,
        'home-health',
        'request-initial',
      ],
      { state: state ?? {} }
    );
  }
}
